import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Gift,
  Plan,
  Speakers,
  About,
  Reg
} from "../../../components/LandingTemplates/gz";

const TITLE = 'Гаджет–зависимость | Центр образовательных технологий Advance';
const DESCRIPTION = 'На бесплатном вебинаре вы получите алгоритм вывода ребенка из гаджет-зависимости, а также непосредственно на вебинаре вы попробуете на практике подкрепить интерес ребенка к учебе! | Центр образовательных технологий Advance ✅Уникальные методики обучения ✅ Эффективное запоминание материала ✅100% результат ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'a94c41dd5e8bc5431d2461130d37496a1a3cba88'} id={'1203581'} />) }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ color: '#343A40' }}>
      <Screen1 id={'gz'}/>
      <Gift/>
      <Plan/>
      <Speakers/>
      <About/>
      <Reg widget={widget}/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
